import React from 'react'
import { IonIcon, IonItemGroup, IonLabel, IonText } from '@ionic/react'
import { chatbubble } from 'ionicons/icons'
import './QaFlagCommentsBlock.component.css'

export interface IQaFlagCommentsBlockProps {
  text: string
  commentsLabel: string
  isExpanded?: boolean
}

const QaFlagCommentsBlock: React.FC<IQaFlagCommentsBlockProps> = ({ text, commentsLabel, isExpanded = false }) => {
  return (
    <IonItemGroup className={`qa-flag-comments-block${isExpanded ? ' qa-flag-comments-block-focused' : ''}`}>
      <div className='qa-flag-comments-header'>
        <IonIcon icon={chatbubble} className='qa-flag-comments-icon' aria-hidden='true' />
        <IonLabel className='qa-flag-comments-label fw-700 font-size-16'>{commentsLabel}</IonLabel>
      </div>
      <IonText className='qa-flag-comments-scroll qa-flag-comments-text fw-400' data-testid='FlagCommentsPanel'>
        {text}
      </IonText>
    </IonItemGroup>
  )
}

export default QaFlagCommentsBlock
